import React from 'react';

import AlertModal from '../../AlertModal';

interface ModalAlertsProps {
  showConfirmationModal: boolean;
  showNoCreditsModal?: boolean;
  open?: boolean;
  handleConfirmClose: () => void;
  handleCancelNoCreditsModal?: () => void;
  handleRedirectToTopup?: () => void;
  setShowConfirmationModal: (value: boolean) => void;
}

const ModalAlerts: React.FC<ModalAlertsProps> = ({
  showConfirmationModal,
  showNoCreditsModal,
  open,
  handleConfirmClose,
  handleCancelNoCreditsModal,
  handleRedirectToTopup,
  setShowConfirmationModal,
}) => {
  return (
    <>
      {showConfirmationModal && (
        <AlertModal
          bodyText="All progress will be lost. To preserve your work, download or copy the content before closing."
          confirmButtonText="Yes, I'm sure"
          isOpen={showConfirmationModal}
          titleText="Are you sure?"
          onCancel={() => setShowConfirmationModal(false)}
          onConfirm={handleConfirmClose}
        />
      )}
      {showNoCreditsModal && (
        <AlertModal
          hasDivider
          bodyText="Please top up to generate more activities."
          confirmButtonText="Top Up"
          isOpen={showNoCreditsModal && open}
          titleText="Not Enough Credits"
          onCancel={handleCancelNoCreditsModal}
          onConfirm={handleRedirectToTopup}
        />
      )}
    </>
  );
};

export default ModalAlerts;
